// Popular emojis with shortcodes for autocomplete
export const emojis = [
  // Smileys & Emotion
  { emoji: '😀', name: 'grinning', keywords: ['smile', 'happy', 'joy'] },
  { emoji: '😃', name: 'smiley', keywords: ['smile', 'happy', 'joy'] },
  { emoji: '😄', name: 'smile', keywords: ['happy', 'joy'] },
  { emoji: '😁', name: 'grin', keywords: ['smile', 'joy'] },
  { emoji: '😆', name: 'laughing', keywords: ['happy', 'joy', 'haha'] },
  { emoji: '😅', name: 'sweat_smile', keywords: ['hot', 'joy'] },
  { emoji: '🤣', name: 'rofl', keywords: ['lol', 'laughing'] },
  { emoji: '😂', name: 'joy', keywords: ['tears', 'lol'] },
  { emoji: '🙂', name: 'slightly_smiling_face', keywords: ['smile'] },
  { emoji: '🙃', name: 'upside_down_face', keywords: ['silly'] },
  { emoji: '😉', name: 'wink', keywords: ['flirt'] },
  { emoji: '😊', name: 'blush', keywords: ['smile', 'happy', 'joy'] },
  { emoji: '😇', name: 'innocent', keywords: ['angel'] },
  { emoji: '🥰', name: 'smiling_face_with_hearts', keywords: ['love', 'crush'] },
  { emoji: '😍', name: 'heart_eyes', keywords: ['love', 'crush'] },
  { emoji: '🤩', name: 'star_struck', keywords: ['eyes', 'star'] },
  { emoji: '😘', name: 'kissing_heart', keywords: ['love', 'kiss'] },
  { emoji: '😗', name: 'kissing', keywords: ['kiss'] },
  { emoji: '😚', name: 'kissing_closed_eyes', keywords: ['kiss'] },
  { emoji: '😙', name: 'kissing_smiling_eyes', keywords: ['kiss'] },
  { emoji: '🥲', name: 'smiling_face_with_tear', keywords: ['sad', 'happy', 'joy'] },
  { emoji: '😋', name: 'yum', keywords: ['tongue', 'licking'] },
  { emoji: '😛', name: 'stuck_out_tongue', keywords: ['tongue'] },
  { emoji: '😜', name: 'stuck_out_tongue_winking_eye', keywords: ['tongue', 'wink'] },
  { emoji: '🤪', name: 'zany_face', keywords: ['crazy'] },
  { emoji: '😝', name: 'stuck_out_tongue_closed_eyes', keywords: ['tongue'] },
  { emoji: '🤑', name: 'money_mouth_face', keywords: ['rich', 'dollar'] },
  { emoji: '🤗', name: 'hugs', keywords: ['hug'] },
  { emoji: '🤭', name: 'hand_over_mouth', keywords: ['quiet', 'whoops'] },
  { emoji: '🤫', name: 'shushing_face', keywords: ['quiet', 'ssh'] },
  { emoji: '🤔', name: 'thinking', keywords: ['hmm'] },
  { emoji: '🤐', name: 'zipper_mouth_face', keywords: ['secret', 'zip'] },
  { emoji: '🤨', name: 'raised_eyebrow', keywords: ['suspicious'] },
  { emoji: '😐', name: 'neutral_face', keywords: ['meh'] },
  { emoji: '😑', name: 'expressionless', keywords: ['blank'] },
  { emoji: '😶', name: 'no_mouth', keywords: ['silent'] },
  { emoji: '😏', name: 'smirk', keywords: ['smug'] },
  { emoji: '😒', name: 'unamused', keywords: ['unhappy'] },
  { emoji: '🙄', name: 'roll_eyes', keywords: ['eye_roll'] },
  { emoji: '😬', name: 'grimacing', keywords: ['awkward'] },
  { emoji: '🤥', name: 'lying_face', keywords: ['pinocchio', 'liar'] },
  { emoji: '😌', name: 'relieved', keywords: ['calm'] },
  { emoji: '😔', name: 'pensive', keywords: ['sad'] },
  { emoji: '😪', name: 'sleepy', keywords: ['tired'] },
  { emoji: '🤤', name: 'drooling_face', keywords: ['drool'] },
  { emoji: '😴', name: 'sleeping', keywords: ['zzz', 'tired'] },
  { emoji: '😷', name: 'mask', keywords: ['sick', 'covid'] },
  { emoji: '🤒', name: 'face_with_thermometer', keywords: ['sick', 'ill'] },
  { emoji: '🤕', name: 'face_with_head_bandage', keywords: ['hurt', 'injured'] },
  { emoji: '🤢', name: 'nauseated_face', keywords: ['sick', 'gross'] },
  { emoji: '🤮', name: 'vomiting_face', keywords: ['sick', 'puke'] },
  { emoji: '🤧', name: 'sneezing_face', keywords: ['achoo', 'sick'] },
  { emoji: '🥵', name: 'hot_face', keywords: ['hot', 'heat'] },
  { emoji: '🥶', name: 'cold_face', keywords: ['cold', 'freezing'] },
  { emoji: '😵', name: 'dizzy_face', keywords: ['dizzy', 'spinning'] },
  { emoji: '🤯', name: 'exploding_head', keywords: ['mind_blown', 'wow'] },
  { emoji: '😕', name: 'confused', keywords: ['puzzled'] },
  { emoji: '😟', name: 'worried', keywords: ['concern'] },
  { emoji: '🙁', name: 'slightly_frowning_face', keywords: ['sad'] },
  { emoji: '☹️', name: 'frowning_face', keywords: ['sad'] },
  { emoji: '😮', name: 'open_mouth', keywords: ['wow', 'surprise'] },
  { emoji: '😯', name: 'hushed', keywords: ['wow', 'surprise'] },
  { emoji: '😲', name: 'astonished', keywords: ['wow', 'surprise'] },
  { emoji: '😳', name: 'flushed', keywords: ['embarrassed'] },
  { emoji: '🥺', name: 'pleading_face', keywords: ['puppy_eyes', 'please'] },
  { emoji: '😦', name: 'frowning', keywords: ['sad'] },
  { emoji: '😧', name: 'anguished', keywords: ['sad', 'worried'] },
  { emoji: '😨', name: 'fearful', keywords: ['scared', 'fear'] },
  { emoji: '😰', name: 'cold_sweat', keywords: ['nervous'] },
  { emoji: '😥', name: 'disappointed_relieved', keywords: ['sad'] },
  { emoji: '😢', name: 'cry', keywords: ['sad', 'tears'] },
  { emoji: '😭', name: 'sob', keywords: ['cry', 'tears', 'sad'] },
  { emoji: '😱', name: 'scream', keywords: ['horror', 'scared'] },
  { emoji: '😖', name: 'confounded', keywords: ['confused'] },
  { emoji: '😣', name: 'persevere', keywords: ['struggle'] },
  { emoji: '😞', name: 'disappointed', keywords: ['sad'] },
  { emoji: '😓', name: 'sweat', keywords: ['hot'] },
  { emoji: '😩', name: 'weary', keywords: ['tired'] },
  { emoji: '😫', name: 'tired_face', keywords: ['exhausted'] },
  { emoji: '🥱', name: 'yawning_face', keywords: ['tired', 'bored'] },
  { emoji: '😤', name: 'triumph', keywords: ['smug', 'proud'] },
  { emoji: '😡', name: 'rage', keywords: ['angry', 'mad'] },
  { emoji: '😠', name: 'angry', keywords: ['mad'] },
  { emoji: '🤬', name: 'cursing_face', keywords: ['swearing', 'angry'] },
  { emoji: '😈', name: 'smiling_imp', keywords: ['devil', 'evil'] },
  { emoji: '👿', name: 'imp', keywords: ['devil', 'evil'] },
  { emoji: '💀', name: 'skull', keywords: ['dead', 'death'] },
  { emoji: '☠️', name: 'skull_and_crossbones', keywords: ['danger', 'death'] },
  
  // Gestures & Body Parts
  { emoji: '👋', name: 'wave', keywords: ['hello', 'hi', 'bye'] },
  { emoji: '🤚', name: 'raised_back_of_hand', keywords: ['hand'] },
  { emoji: '🖐️', name: 'hand', keywords: ['five'] },
  { emoji: '✋', name: 'raised_hand', keywords: ['stop'] },
  { emoji: '🖖', name: 'vulcan_salute', keywords: ['spock'] },
  { emoji: '👌', name: 'ok_hand', keywords: ['ok', 'perfect'] },
  { emoji: '🤌', name: 'pinched_fingers', keywords: ['italian'] },
  { emoji: '🤏', name: 'pinching_hand', keywords: ['small'] },
  { emoji: '✌️', name: 'v', keywords: ['peace', 'victory'] },
  { emoji: '🤞', name: 'crossed_fingers', keywords: ['luck', 'hope'] },
  { emoji: '🤟', name: 'love_you_gesture', keywords: ['ily'] },
  { emoji: '🤘', name: 'metal', keywords: ['rock'] },
  { emoji: '🤙', name: 'call_me_hand', keywords: ['phone', 'shaka'] },
  { emoji: '👈', name: 'point_left', keywords: ['left'] },
  { emoji: '👉', name: 'point_right', keywords: ['right'] },
  { emoji: '👆', name: 'point_up_2', keywords: ['up'] },
  { emoji: '🖕', name: 'middle_finger', keywords: ['fu'] },
  { emoji: '👇', name: 'point_down', keywords: ['down'] },
  { emoji: '☝️', name: 'point_up', keywords: ['up'] },
  { emoji: '👍', name: 'thumbsup', keywords: ['yes', 'ok', 'good', 'like', '+1'] },
  { emoji: '👎', name: 'thumbsdown', keywords: ['no', 'bad', 'dislike', '-1'] },
  { emoji: '✊', name: 'fist', keywords: ['power'] },
  { emoji: '👊', name: 'facepunch', keywords: ['punch'] },
  { emoji: '🤛', name: 'fist_left', keywords: ['punch'] },
  { emoji: '🤜', name: 'fist_right', keywords: ['punch'] },
  { emoji: '👏', name: 'clap', keywords: ['applause', 'praise'] },
  { emoji: '🙌', name: 'raised_hands', keywords: ['hooray', 'yay'] },
  { emoji: '👐', name: 'open_hands', keywords: ['hug'] },
  { emoji: '🤝', name: 'handshake', keywords: ['deal', 'agreement'] },
  { emoji: '🙏', name: 'pray', keywords: ['please', 'thanks', 'hope'] },
  { emoji: '✍️', name: 'writing_hand', keywords: ['write'] },
  { emoji: '💪', name: 'muscle', keywords: ['strong', 'flex'] },
  { emoji: '🦾', name: 'mechanical_arm', keywords: ['prosthetic'] },
  { emoji: '🦿', name: 'mechanical_leg', keywords: ['prosthetic'] },
  { emoji: '🦵', name: 'leg', keywords: ['kick'] },
  { emoji: '🦶', name: 'foot', keywords: ['kick'] },
  { emoji: '👂', name: 'ear', keywords: ['hear', 'listen'] },
  { emoji: '🦻', name: 'ear_with_hearing_aid', keywords: ['accessibility'] },
  { emoji: '👃', name: 'nose', keywords: ['smell'] },
  { emoji: '🧠', name: 'brain', keywords: ['smart'] },
  { emoji: '🦷', name: 'tooth', keywords: ['dentist'] },
  { emoji: '🦴', name: 'bone', keywords: ['skeleton'] },
  { emoji: '👀', name: 'eyes', keywords: ['look', 'see', 'watch'] },
  { emoji: '👁️', name: 'eye', keywords: ['look'] },
  { emoji: '👅', name: 'tongue', keywords: ['taste'] },
  { emoji: '👄', name: 'lips', keywords: ['kiss', 'mouth'] },
  
  // Hearts & Symbols
  { emoji: '💋', name: 'kiss', keywords: ['lips'] },
  { emoji: '💘', name: 'cupid', keywords: ['love', 'heart'] },
  { emoji: '💝', name: 'gift_heart', keywords: ['love'] },
  { emoji: '💖', name: 'sparkling_heart', keywords: ['love'] },
  { emoji: '💗', name: 'heartpulse', keywords: ['love'] },
  { emoji: '💓', name: 'heartbeat', keywords: ['love'] },
  { emoji: '💞', name: 'revolving_hearts', keywords: ['love'] },
  { emoji: '💕', name: 'two_hearts', keywords: ['love'] },
  { emoji: '💟', name: 'heart_decoration', keywords: ['love'] },
  { emoji: '❣️', name: 'heavy_heart_exclamation', keywords: ['love'] },
  { emoji: '💔', name: 'broken_heart', keywords: ['sad', 'heartbreak'] },
  { emoji: '❤️', name: 'heart', keywords: ['love'] },
  { emoji: '🧡', name: 'orange_heart', keywords: ['love'] },
  { emoji: '💛', name: 'yellow_heart', keywords: ['love'] },
  { emoji: '💚', name: 'green_heart', keywords: ['love'] },
  { emoji: '💙', name: 'blue_heart', keywords: ['love'] },
  { emoji: '💜', name: 'purple_heart', keywords: ['love'] },
  { emoji: '🤎', name: 'brown_heart', keywords: ['love'] },
  { emoji: '🖤', name: 'black_heart', keywords: ['love'] },
  { emoji: '🤍', name: 'white_heart', keywords: ['love'] },
  
  // Popular Objects & Animals
  { emoji: '🔥', name: 'fire', keywords: ['hot', 'lit', 'burn'] },
  { emoji: '⭐', name: 'star', keywords: ['favorite'] },
  { emoji: '✨', name: 'sparkles', keywords: ['shiny'] },
  { emoji: '💯', name: '100', keywords: ['perfect', 'hundred'] },
  { emoji: '💥', name: 'boom', keywords: ['explosion'] },
  { emoji: '💫', name: 'dizzy', keywords: ['star'] },
  { emoji: '💦', name: 'sweat_drops', keywords: ['water'] },
  { emoji: '💨', name: 'dash', keywords: ['fast', 'wind'] },
  { emoji: '🎉', name: 'tada', keywords: ['party', 'celebration'] },
  { emoji: '🎊', name: 'confetti_ball', keywords: ['party'] },
  { emoji: '🎈', name: 'balloon', keywords: ['party'] },
  { emoji: '🎁', name: 'gift', keywords: ['present', 'birthday'] },
  { emoji: '🏆', name: 'trophy', keywords: ['win', 'award'] },
  { emoji: '🥇', name: 'first_place_medal', keywords: ['gold', 'winner'] },
  { emoji: '🥈', name: 'second_place_medal', keywords: ['silver'] },
  { emoji: '🥉', name: 'third_place_medal', keywords: ['bronze'] },
  { emoji: '⚡', name: 'zap', keywords: ['lightning', 'fast'] },
  { emoji: '☀️', name: 'sunny', keywords: ['sun', 'weather'] },
  { emoji: '🌙', name: 'crescent_moon', keywords: ['night'] },
  { emoji: '⭐', name: 'star', keywords: ['night'] },
  { emoji: '🌟', name: 'star2', keywords: ['glow'] },
  { emoji: '✅', name: 'white_check_mark', keywords: ['done', 'yes'] },
  { emoji: '❌', name: 'x', keywords: ['no', 'wrong'] },
  { emoji: '❗', name: 'exclamation', keywords: ['bang'] },
  { emoji: '❓', name: 'question', keywords: ['confused'] },
  { emoji: '💬', name: 'speech_balloon', keywords: ['comment', 'chat'] },
  { emoji: '💭', name: 'thought_balloon', keywords: ['thinking'] },
  { emoji: '🚀', name: 'rocket', keywords: ['space', 'launch'] },
  { emoji: '🎯', name: 'dart', keywords: ['target', 'bullseye'] },
  { emoji: '⚠️', name: 'warning', keywords: ['alert', 'caution'] },
  { emoji: '🚨', name: 'rotating_light', keywords: ['alert', 'emergency'] },
  { emoji: '📱', name: 'iphone', keywords: ['phone', 'mobile'] },
  { emoji: '💻', name: 'computer', keywords: ['laptop', 'pc'] },
  { emoji: '⌨️', name: 'keyboard', keywords: ['typing'] },
  { emoji: '🖥️', name: 'desktop_computer', keywords: ['pc'] },
  { emoji: '🖱️', name: 'computer_mouse', keywords: ['click'] },
  { emoji: '🎮', name: 'video_game', keywords: ['game', 'controller'] },
  { emoji: '🎵', name: 'musical_note', keywords: ['music'] },
  { emoji: '🎶', name: 'notes', keywords: ['music'] },
  { emoji: '🎤', name: 'microphone', keywords: ['sing', 'karaoke'] },
  { emoji: '🎧', name: 'headphones', keywords: ['music'] },
  { emoji: '📷', name: 'camera', keywords: ['photo'] },
  { emoji: '📸', name: 'camera_flash', keywords: ['photo'] },
  { emoji: '🎥', name: 'movie_camera', keywords: ['film', 'video'] },
  { emoji: '📺', name: 'tv', keywords: ['television'] },
  { emoji: '📖', name: 'book', keywords: ['read'] },
  { emoji: '📚', name: 'books', keywords: ['library', 'read'] },
  { emoji: '✏️', name: 'pencil2', keywords: ['write'] },
  { emoji: '📝', name: 'memo', keywords: ['note', 'write'] },
  { emoji: '🍕', name: 'pizza', keywords: ['food'] },
  { emoji: '🍔', name: 'hamburger', keywords: ['food', 'burger'] },
  { emoji: '🍟', name: 'fries', keywords: ['food'] },
  { emoji: '🌮', name: 'taco', keywords: ['food'] },
  { emoji: '🍿', name: 'popcorn', keywords: ['movie', 'snack'] },
  { emoji: '🍩', name: 'doughnut', keywords: ['food', 'donut'] },
  { emoji: '🍰', name: 'cake', keywords: ['dessert', 'birthday'] },
  { emoji: '🎂', name: 'birthday', keywords: ['cake', 'party'] },
  { emoji: '🍺', name: 'beer', keywords: ['drink', 'cheers'] },
  { emoji: '🍻', name: 'beers', keywords: ['cheers', 'drink'] },
  { emoji: '🥂', name: 'champagne_glass', keywords: ['cheers', 'celebration'] },
  { emoji: '🍷', name: 'wine_glass', keywords: ['drink'] },
  { emoji: '☕', name: 'coffee', keywords: ['cafe', 'drink'] },
  { emoji: '🍵', name: 'tea', keywords: ['drink'] },
  
  // Animals
  { emoji: '🐶', name: 'dog_face', keywords: ['puppy', 'pet', 'dog'] },
  { emoji: '🐕', name: 'dog', keywords: ['puppy', 'pet', 'dog'] },
  { emoji: '🦮', name: 'dog_guide', keywords: ['puppy', 'pet', 'dog'] },
  { emoji: '🐕‍', name: 'dog_service', keywords: ['puppy', 'pet', 'dog'] },
  { emoji: '🐩', name: 'dog_poodle', keywords: ['puppy', 'pet', 'dog'] },
  { emoji: '🌭', name: 'hotdog', keywords: ['dog'] },
  { emoji: '🐱', name: 'cat', keywords: ['kitty', 'pet'] },
  { emoji: '🐭', name: 'mouse', keywords: ['animal'] },
  { emoji: '🐹', name: 'hamster', keywords: ['pet'] },
  { emoji: '🐰', name: 'rabbit', keywords: ['bunny'] },
  { emoji: '🦊', name: 'fox', keywords: ['animal'] },
  { emoji: '🐻', name: 'bear', keywords: ['animal'] },
  { emoji: '🐼', name: 'panda_face', keywords: ['animal'] },
  { emoji: '🐨', name: 'koala', keywords: ['animal'] },
  { emoji: '🐯', name: 'tiger', keywords: ['animal'] },
  { emoji: '🦁', name: 'lion', keywords: ['animal'] },
  { emoji: '🐮', name: 'cow', keywords: ['animal'] },
  { emoji: '🐷', name: 'pig', keywords: ['animal'] },
  { emoji: '🐸', name: 'frog', keywords: ['animal'] },
  { emoji: '🐵', name: 'monkey_face', keywords: ['animal'] },
  { emoji: '🙈', name: 'see_no_evil', keywords: ['monkey'] },
  { emoji: '🙉', name: 'hear_no_evil', keywords: ['monkey'] },
  { emoji: '🙊', name: 'speak_no_evil', keywords: ['monkey'] },
  { emoji: '🐔', name: 'chicken', keywords: ['bird'] },
  { emoji: '🐧', name: 'penguin', keywords: ['bird'] },
  { emoji: '🐦', name: 'bird', keywords: ['animal'] },
  { emoji: '🦅', name: 'eagle', keywords: ['bird'] },
  { emoji: '🦆', name: 'duck', keywords: ['bird'] },
  { emoji: '🦉', name: 'owl', keywords: ['bird'] },
  { emoji: '🦇', name: 'bat', keywords: ['vampire'] },
  { emoji: '🐺', name: 'wolf', keywords: ['animal'] },
  { emoji: '🐗', name: 'boar', keywords: ['pig'] },
  { emoji: '🐴', name: 'horse', keywords: ['animal'] },
  { emoji: '🦄', name: 'unicorn', keywords: ['magical'] },
  { emoji: '🐝', name: 'bee', keywords: ['insect', 'honey'] },
  { emoji: '🐛', name: 'bug', keywords: ['insect'] },
  { emoji: '🦋', name: 'butterfly', keywords: ['insect'] },
  { emoji: '🐌', name: 'snail', keywords: ['slow'] },
  { emoji: '🐞', name: 'ladybug', keywords: ['insect'] },
  { emoji: '🐜', name: 'ant', keywords: ['insect'] },
  { emoji: '🕷️', name: 'spider', keywords: ['insect'] },
  { emoji: '🕸️', name: 'spider_web', keywords: ['web'] },
  { emoji: '🐢', name: 'turtle', keywords: ['slow'] },
  { emoji: '🐍', name: 'snake', keywords: ['animal'] },
  { emoji: '🦎', name: 'lizard', keywords: ['animal'] },
  { emoji: '🦖', name: 't-rex', keywords: ['dinosaur'] },
  { emoji: '🦕', name: 'sauropod', keywords: ['dinosaur'] },
  { emoji: '🐙', name: 'octopus', keywords: ['animal'] },
  { emoji: '🦑', name: 'squid', keywords: ['animal'] },
  { emoji: '🦐', name: 'shrimp', keywords: ['animal'] },
  { emoji: '🦞', name: 'lobster', keywords: ['animal'] },
  { emoji: '🦀', name: 'crab', keywords: ['animal'] },
  { emoji: '🐡', name: 'blowfish', keywords: ['fish'] },
  { emoji: '🐠', name: 'tropical_fish', keywords: ['fish'] },
  { emoji: '🐟', name: 'fish', keywords: ['animal'] },
  { emoji: '🐬', name: 'dolphin', keywords: ['animal'] },
  { emoji: '🐳', name: 'whale', keywords: ['animal'] },
  { emoji: '🐋', name: 'whale2', keywords: ['animal'] },
  { emoji: '🦈', name: 'shark', keywords: ['animal'] }
];

// Fast lookup for exact matches
export const emojiMap = emojis.reduce((acc, item) => {
  acc[item.name] = item.emoji;
  return acc;
}, {});

// Search function for autocomplete
export function searchEmojis(query) {
  if (!query || query.length < 2) return [];
  
  const lowerQuery = query.toLowerCase();
  const results = [];
  
  for (const item of emojis) {
    // Check name match
    if (item.name.includes(lowerQuery)) {
      results.push({ ...item, matchType: 'name' });
      if (results.length >= 10) break;
      continue;
    }
    
    // Check keywords match
    if (item.keywords.some(kw => kw.includes(lowerQuery))) {
      results.push({ ...item, matchType: 'keyword' });
      if (results.length >= 10) break;
    }
  }
  
  return results;
}
